import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../i18n/LocaleContext';

/**
 * 通用設定子頁外殼（標題列 + 可置中內容區）
 */
export default function SettingsSubPageShell({ title, children, centered = false }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="settings-sub-page">
      <header className="settings-sub-page__header">
        <button
          type="button"
          className="settings-sub-page__back"
          aria-label={t('common.back')}
          onClick={() => navigate(-1)}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path
              d="M15 6l-6 6 6 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <h1 className="settings-sub-page__title">{title}</h1>
        <span className="settings-sub-page__spacer" aria-hidden />
      </header>
      <div className={`settings-sub-page__body ${centered ? 'is-centered' : ''}`}>{children}</div>
    </div>
  );
}
